export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/news_fill.1334682b.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};